'use client'

import Image from 'next/image'
import { useTranslateEntry } from 'src/i18n/client/useTranslateEntry'

// Okładka filmu przed odtworzeniem: kadr (albo granatowe tło), przyciemnienie i przycisk play.
// Wspólna dla bloku z filmem, abstraktu artykułu i bloku tekstowego z wideo na stronie głównej.
const VideoPoster = ({
  src,
  alt = '',
  width,
  height,
  onPlay,
  imageClassName = 'h-full min-h-[inherit] w-full object-cover',
  fallbackClassName = 'min-h-[inherit] w-full',
}) => {
  const translateEntry = useTranslateEntry()

  return (
    <>
      {src ? (
        <Image src={src} alt={alt} width={width} height={height} className={imageClassName} />
      ) : (
        <div className={`${fallbackClassName} bg-dark-blue-dark-blue1/40`} aria-hidden="true" />
      )}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          backgroundImage:
            'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 100%), linear-gradient(90deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%)',
        }}
      />
      {onPlay && (
        <button
          type="button"
          onClick={onPlay}
          className="media-overlay cursor-pointer absolute left-1/2 top-1/2 flex t:h-112 t:w-112 w-45 h-45 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border-2 border-basic-white bg-black/30 text-basic-white transition hover:bg-black/60 focus-visible:outline focus-visible:outline-offset-4 focus-visible:outline-functional-focus-color"
          aria-label={translateEntry('T_PLAY_VIDEO')}
        >
          <span className="ml-2 inline-block h-0 w-0 t:border-y-14 border-y-7 border-y-transparent t:border-l-24 border-l-12 border-l-basic-white" />
        </button>
      )}
    </>
  )
}

export { VideoPoster }
